import React from 'react';

const IconWrap: React.FC<{ bg: string; children: React.ReactNode }> = ({ bg, children }) => (
    <div className="flex flex-col items-center">
        <div className={`w-20 h-20 rounded-2xl grid place-items-center ${bg}`}>{children}</div>
    </div>
);

const PostHeroAbout: React.FC = () => {
    return (
        <section>
            {/* Pink Intro Box */}
            <div className="bg-rose-100">
                <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-10">
                    <h3 className="text-2xl md:text-3xl font-semibold text-[#da291c]">
                        JEEVAN JYOTI FOUNDATION
                    </h3>
                    <p className="mt-4 text-gray-700 leading-relaxed">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorum autem ipsam qui dolor aut iusto hic illo quaerat ad, voluptates porro facilis architecto rerum cum quam quod nisi. In illum quod expedita dicta quidem necessitatibus?
                    </p>
                    <p className="mt-3 text-gray-700 leading-relaxed">
                        Our holistic approach addresses multiple aspects of childhood, supports psychosocial needs,
                        and enables equal opportunities so that children can thrive as architects of tomorrow.
                    </p>
                    <button className="mt-5 inline-flex px-5 py-2.5 rounded-md text-white bg-[#da291c] hover:bg-[#b11f15]">
                        Read More...
                    </button>
                </div>
            </div>

            {/* Our Fields of Work */}
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12">
                <h4 className="text-center text-[#da291c] text-2xl md:text-3xl font-semibold">
                    OUR FIELDS OF WORK
                </h4>
                <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-start text-center">
                    <div>
                        <IconWrap bg="bg-cyan-100">
                            <span className="text-3xl">AB</span>
                        </IconWrap>
                        <div className="mt-3 font-semibold text-sm">EDUCATION</div>
                    </div>
                    <div>
                        <IconWrap bg="bg-rose-100">
                            <span className="text-3xl">+</span>
                        </IconWrap>
                        <div className="mt-3 font-semibold text-sm">HEALTH</div>
                    </div>
                    <div>
                        <IconWrap bg="bg-amber-100">
                            <span className="text-3xl">⚡</span>
                        </IconWrap>
                        <div className="mt-3 font-semibold text-sm">RESILIENCE</div>
                    </div>
                    <div>
                        <IconWrap bg="bg-emerald-100">
                            <span className="text-3xl">🌿</span>
                        </IconWrap>
                        <div className="mt-3 font-semibold text-sm">LIVELIHOOD</div>
                    </div>
                    <div>
                        <IconWrap bg="bg-orange-100">
                            <span className="text-3xl">🛡️</span>
                        </IconWrap>
                        <div className="mt-3 font-semibold text-sm">PROTECTION</div>
                    </div>
                    <div>
                        <IconWrap bg="bg-violet-100">
                            <span className="text-3xl">🏆</span>
                        </IconWrap>
                        <div className="mt-3 font-semibold text-sm">HUMANITARIAN</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PostHeroAbout;


